
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface StudentSearchProps {
  searchQuery: string;
  onSearch: (query: string) => void;
}

export const StudentSearch: React.FC<StudentSearchProps> = ({ searchQuery, onSearch }) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };

  return (
    <div className="relative flex-grow">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="ค้นหานักเรียน (ชื่อ, รหัส, ชื่อเล่น)"
        value={searchQuery}
        onChange={handleSearchChange}
        className="pl-10 pr-4"
      />
    </div>
  );
};
